"use client";

import { useState } from "react";
import { Ruler, ShoppingCart } from "lucide-react";
import { useTranslations } from "next-intl";

import { cn } from "@/lib/cn";
import { formatRupiah } from "@/lib/mock/data";

export function SizePicker({ sizes, price }: { sizes: string[]; price: number }) {
  const t = useTranslations("Store");
  const [size, setSize] = useState<string | null>(null);

  return (
    <>
      <section>
        <div className="mb-stack-md flex items-center justify-between">
          <h2 className="font-headline text-headline-md text-on-surface">{t("pilihUkuran")}</h2>
          <button className="flex items-center gap-1 font-label text-label-caps uppercase text-primary-container">
            {t("sizeChart")}
            <Ruler className="size-4" aria-hidden />
          </button>
        </div>

        <div className="flex flex-wrap gap-2" role="group" aria-label={t("pilihUkuranAria")}>
          {sizes.map((s) => (
            <button
              key={s}
              onClick={() => setSize(s)}
              aria-pressed={size === s}
              className={cn(
                "min-w-14 rounded-xl border px-4 py-2.5 font-semibold transition-all active:scale-95",
                size === s
                  ? "border-primary bg-primary-container/20 text-primary"
                  : "border-outline-variant/30 bg-surface-base text-on-surface-variant hover:border-primary-container",
              )}
            >
              {s}
            </button>
          ))}
        </div>
      </section>

      <div className="glass-blur fixed inset-x-0 bottom-16 z-40 mx-auto max-w-lg border-t border-outline-variant/10 p-container-margin">
        <div className="flex items-center justify-between gap-4">
          <div>
            <p className="font-label text-label-caps uppercase text-on-surface-variant">
              {size ? t("ukuranX", { size }) : t("pilihUkuranDulu")}
            </p>
            <p className="font-headline text-headline-md text-primary">
              {formatRupiah(price)}
            </p>
          </div>
          <button
            disabled={!size}
            className={cn(
              "flex h-14 max-w-60 flex-1 items-center justify-center gap-2 rounded-full font-headline text-headline-md font-bold transition-transform",
              size
                ? "kinetic-gradient text-white shadow-[0_10px_25px_rgb(241,102,6,0.3)] active:scale-95"
                : "cursor-not-allowed bg-surface-container text-on-surface-variant/40",
            )}
          >
            <ShoppingCart className="size-5" aria-hidden />
            {t("tambah")}
          </button>
        </div>
      </div>
    </>
  );
}
